/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ERROR_CODES = {
    ITEM_IS_NOT_AVAILABLE: 'product_is_not_available',
    NOT_ENOUGH_PERSONAL_FAME_POINTS: 'not_enough_personal_fame_points',
    USER_ALREADY_BOUGHT_THIS_PRODUCT: 'user_already_bought_this_product',
    TANK_IS_ALREADY_SELECTED: 'tank_is_already_selected',
    TANK_IS_ALREADY_IN_HANGAR: 'tank_already_in_hangar',
    BET_ALREADY_EXISTS: 'bet_already_exists',
    BET_DOESNT_EXIST: 'bet_doesnt_exist',
    AUCTION_TICKET_IS_NOT_FOUND: 'auction_ticket_is_not_found',
    NOT_ENOUGH_FUNDS: 'not_enough_funds',
    NOT_ENOUGH_RESOURCES_FOR_REWARD_PACK: 'not_enough_resources_for_reward_pack',
    TURN_CALCULATION_IN_PROGRESS: 'turn_calculation_in_progress',
    AUCTION_IS_DISABLED: 'auction_is_disabled',
    BET_IS_LOWER_THAN_MINIMUM: 'bet_is_lower_than_minimum',
    REWARDING_IS_FINISHED: 'Not found',
    // Frontend generated error codes in uppercase
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    PRODUCTS_UNKNOWN_ERROR: 'PRODUCTS_UNKNOWN_ERROR',
    REWARDS_UNKNOWN_ERROR: 'REWARDS_UNKNOWN_ERROR',
    WG_MONEY_UNAVAILABILE: 'external_service_error',
}

export const ERROR_ACTION_TYPES = {
    REQUEST_ITEMS: 'REQUEST_ITEMS',
    PRODUCTS_REQUEST_ITEMS: 'PRODUCTS_REQUEST_ITEMS',
    REWARDS_REQUEST_ITEMS: 'REWARDS_REQUEST_ITEMS',
    PURCHASE_ITEM: 'PURCHASE_ITEM',
    PRODUCTS_PURCHASE_ITEM: 'PRODUCTS_PURCHASE_ITEM',
    REWARDS_PURCHASE_ITEM: 'REWARDS_PURCHASE_ITEM',
    MAKE_TANK_BET: 'MAKE_TANK_BET',
    CANCEL_TANK_BET: 'CANCEL_TANK_BET',
    PURCHASE_PRODUCT: 'PURCHASE_PRODUCT',
}

export const ERROR_TITLES = {
    [ERROR_ACTION_TYPES.PRODUCTS_REQUEST_ITEMS]: {
        [ERROR_CODES.REWARDING_IS_FINISHED]: (
            <FormattedMessage
                id='wgcwx_shop_errors.titles.products_is_not_available'
                defaultMessage='Бонусы недоступны'
            />
        ),
        [ERROR_CODES.PRODUCTS_UNKNOWN_ERROR]: (
            <FormattedMessage
                id='wgcwx_shop_errors.titles.products_is_not_showed'
                defaultMessage='Не удалось отобразить список бонусов'
            />
        ),
    },
    [ERROR_ACTION_TYPES.REWARDS_REQUEST_ITEMS]: {
        [ERROR_CODES.REWARDING_IS_FINISHED]: (
            <FormattedMessage
                id='wgcwx_shop_errors.titles.rewards_is_not_available'
                defaultMessage='Награды недоступны'
            />
        ),
        [ERROR_CODES.REWARDS_UNKNOWN_ERROR]: (
            <FormattedMessage
                id='wgcwx_shop_errors.titles.rewards_is_not_showed'
                defaultMessage='Не удалось отобразить список наград'
            />
        ),
    },
    [ERROR_ACTION_TYPES.PRODUCTS_PURCHASE_ITEM]: (
        <FormattedMessage
            id='wgcwx_shop_errors.titles.product_get_is_failed'
            defaultMessage='Не удалось получить бонус'
        />
    ),
    [ERROR_ACTION_TYPES.REWARDS_PURCHASE_ITEM]: (
        <FormattedMessage
            id='wgcwx_shop_errors.titles.reward_get_is_failed'
            defaultMessage='Не удалось получить награду'
        />
    ),
    [ERROR_ACTION_TYPES.MAKE_TANK_BET]: (
        <FormattedMessage
            id='wgcwx_shop.errors.titles.make_tank_bet_failed'
            defaultMessage='Не удалось сделать ставку на аукционе'
        />
    ),
    [ERROR_ACTION_TYPES.CANCEL_TANK_BET]: (
        <FormattedMessage
            id='wgcwx_shop.errors.titles.cancel_tank_bet_failed'
            defaultMessage='Не удалось отменить ставку на аукционе'
        />
    ),
}

const NOT_ENOUGH_FUNDS = (
    <FormattedMessage
        id='wgcwx_shop_errors.not_enough_funds'
        defaultMessage='Ваши боны уже были израсходованы до совершения операции.'
    />
)

const REWARDING_IS_FINISHED = (
    <FormattedMessage
        id='wgcwx_shop_errors.rewarding_is_finished'
        defaultMessage='Награждение победителей события завершено.'
    />
)

const TANK_IS_ALREADY_IN_HANGAR = (
    <FormattedMessage
        id='wgcwx_shop_errors.reward_is_already_selected'
        defaultMessage='Награда уже была получена до совершения операции.'
    />
)

export default {
    [ERROR_CODES.REWARDING_IS_FINISHED]: REWARDING_IS_FINISHED,
    [ERROR_CODES.PRODUCTS_UNKNOWN_ERROR]: (
        <FormattedMessage
            id='wgcwx_shop_errors.products_purchase_is_not_available'
            defaultMessage='Приобретение персональных бонусов временно недоступно. Попробуйте позже.'
        />
    ),
    [ERROR_CODES.REWARDS_UNKNOWN_ERROR]: (
        <FormattedMessage
            id='wgcwx_shop_errors.rewards_purchase_is_not_available'
            defaultMessage='Получение наград временно недоступно. Попробуйте позже.'
        />
    ),
    [ERROR_CODES.TURN_CALCULATION_IN_PROGRESS]: (
        <FormattedMessage
            id='wgcwx_shop_errors.turn_calculation_in_progress'
            defaultMessage='На Глобальной карте идёт расчёт хода, попробуйте повторить позже.'
        />
    ),
    [ERROR_CODES.ITEM_IS_NOT_AVAILABLE]: {
        PRODUCTS: (
            <FormattedMessage
                id='wgcwx_shop_errors.product_purchase_is_not_available'
                defaultMessage='Выбранный бонус больше недоступен.'
            />
        ),
        REWARDS: (
            <FormattedMessage
                id='wgcwx_shop_errors.reward_is_not_available'
                defaultMessage='Награда больше недоступна.'
            />
        ),
    },
    [ERROR_CODES.NOT_ENOUGH_PERSONAL_FAME_POINTS]: (
        <FormattedMessage
            id='wgcwx_shop_errors.not_enough_personal_fame_points'
            defaultMessage='Ваши личные Очки славы уже были израсходованы до совершения операции.'
        />
    ),
    [ERROR_CODES.USER_ALREADY_BOUGHT_THIS_PRODUCT]: (
        <FormattedMessage
            id='wgcwx_shop_errors.user_already_bought_this_product'
            defaultMessage='Выбранный персональный бонус уже был получен до совершения операции.'
        />
    ),
    [ERROR_CODES.NOT_ENOUGH_FUNDS]: NOT_ENOUGH_FUNDS,
    [ERROR_CODES.NOT_ENOUGH_RESOURCES_FOR_REWARD_PACK]: NOT_ENOUGH_FUNDS,
    [ERROR_CODES.TANK_IS_ALREADY_SELECTED]: TANK_IS_ALREADY_IN_HANGAR,
    [ERROR_CODES.TANK_IS_ALREADY_IN_HANGAR]: TANK_IS_ALREADY_IN_HANGAR,
    [ERROR_CODES.BET_DOESNT_EXIST]: (
        <FormattedMessage
            id='wgcwx_shop_errors.bet_doesnt_exist'
            defaultMessage='Ставка на аукционе уже была отменена до совершения операции.'
        />
    ),
    [ERROR_CODES.BET_ALREADY_EXISTS]: (
        <FormattedMessage
            id='wgcwx_shop_errors.bet_already_exists'
            defaultMessage='Ставка на аукционе уже была сделана до совершения операции.'
        />
    ),
    [ERROR_CODES.AUCTION_IS_DISABLED]: REWARDING_IS_FINISHED,
    [ERROR_CODES.AUCTION_TICKET_IS_NOT_FOUND]: (
        <FormattedMessage
            id='wgcwx_shop_errors.auction_ticket_is_not_found'
            defaultMessage='У вас нет допуска на аукцион техники.'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/WGCWXShop/errors.js